import {WCBaseComponent} from './WCBaseComponent.js';

const template = document.createElement('template');

template.innerHTML = `
  <a href="#" class="wc-anchor-payload aPayload text-decoration-none">Link</a>
`;

export class WCAnchorPayload extends WCBaseComponent {

  constructor () {
    super();
  }

  render () {
    let contentNodes = [...this.childNodes];
    let clone = template.cloneNode(true);
    let wcAnchorPayload = clone.content.querySelector('.wc-anchor-payload');
    let dataHref = this.getAttribute('data-href');
    let dataPayload = $$.tool.dataJSON(this.getAttribute('data-payload'));
    wcAnchorPayload.innerHTML = '';
    wcAnchorPayload.dataset.payload = encodeURIComponent(JSON.stringify(dataPayload));
    wcAnchorPayload.setAttribute('href', CI.base_url + dataHref);
    contentNodes.forEach(node => {
      wcAnchorPayload.appendChild(node);
    });
    // this.innerHTML = '';
    this.replaceWith(wcAnchorPayload);
  }

}